import { publish, subscribe, unsubscribe } from '@alfa-bank/site-event-bus';

import { BODY_OVERFLOW_SHIFT_EVENT } from './config';

export const publishBodyOverflowShift = (shift: number) => {
    publish<number>(BODY_OVERFLOW_SHIFT_EVENT, shift);
};

/**
 * При добавлении `body` отступа справа, вызывает коллбэк со значением добавленного отступа
 */

/* istanbul ignore next: в тестах подписка почему-то не срабатывает */
export const subscribeBodyOverflowShift = (cb: (shift: number) => void) => {
    subscribe<number>(BODY_OVERFLOW_SHIFT_EVENT, cb);
};

/**
 * Используется в паре с subscribeBodyOverflowShift для удаления слушателя
 */

/* istanbul ignore next: в тестах подписка почему-то не срабатывает, поэтому и отписку нормально протестировать нельзя */
export const unsubscribeBodyOverflowShift = (cb: (shift: number) => void) => {
    unsubscribe<number>(BODY_OVERFLOW_SHIFT_EVENT, cb);
};
